import { render, staticRenderFns } from "./SalesByHistory.vue?vue&type=template&id=128bfe18&scoped=true&"
import script from "./SalesByHistory.vue?vue&type=script&lang=js&"
export * from "./SalesByHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128bfe18",
  null
  
)

export default component.exports